// import Swiper styles
import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// my
import './assets/scss/style.scss';
import './assets/scss/header.scss';
import './assets/scss/sections.scss';
import './assets/scss/footer.scss';
import './assets/scss/card-service.scss';
import './assets/scss/card-advantage.scss';
import './assets/scss/card-rent.scss';
import './assets/scss/card-tool.scss';
import './assets/scss/card-sale.scss';
import './assets/scss/fast-selection.scss';
import './assets/scss/card-repair.scss';
import './assets/scss/card-address.scss';
import './assets/scss/poster-text.scss';
import './assets/scss/card-firm.scss';
import './assets/scss/breadcrumbs.scss';
import './assets/scss/cat-poster.scss';
import './assets/scss/tool.scss';
import './assets/scss/arr-top.scss';

import './assets/scss/stuff.scss';

import './assets/scss/links.scss';
import './assets/scss/buttons.scss';
import './assets/scss/dropdown.scss';

import './assets/scss/added-styles.scss';

//import "./assets/scss/shortened.scss";
import './assets/scss/acc.scss';
//import "./assets/scss/pagination.scss";
import './assets/scss/popup.scss';

//import "./assets/js/tabs.js";
import './assets/js/acc.js';
//import "./assets/js/shortened.js";
import './assets/js/popup.js';

import './assets/js/my.js';
